import { BaseOrganizationEndpoints } from './base';
import { TagGetResponse } from '../types/tags';
import { FavoriteFilters } from '../types/favorites';

export class Favorites extends BaseOrganizationEndpoints {
  async getFavorites(filters?: FavoriteFilters) {
    return this.requestWithStatus<TagGetResponse>('GET', '/v1/me/favorites');
  }

  async addResourceFavorite(resourceId: string) {
    return this.requestWithStatus<TagGetResponse>('POST', '/v1/me/favorites', {
      target_id: resourceId,
      target_type: 'resource'
    });
  }

  async deleteFavorite(id: string) {
    return this.requestWithStatus<TagGetResponse>(
      'DELETE',
      `/v1/me/favorites/${id}`
    );
  }
}
